import LocalizationKeys from './LocalizationKeys'

const French = {
  [LocalizationKeys.Page.Login.Title]: 'Connexion',
  [LocalizationKeys.Page.Login.Submit]: 'Connexion',

  [LocalizationKeys.Page.Register.Title]: 'Inscription',
  [LocalizationKeys.Page.Register.Submit]: 'Inscription',

  [LocalizationKeys.Page.ForgotPassword.Title]: 'Mot de passe oublié',
  [LocalizationKeys.Page.ForgotPassword.Submit]: 'Envoyer',
  [LocalizationKeys.Page.ForgotPassword.Processed]:
    'Vous allez recevoir un email avec un lien de réinitialisation de mot de passe.',
  [LocalizationKeys.Page.ForgotPassword.AlreadyHaveAccount]:
    'Vous avez déjà un compte ? Connexion',

  [LocalizationKeys.Page.ResetPassord.Title]: 'Mot de passe oublié',
  [LocalizationKeys.Page.ResetPassord.Submit]: 'Envoyer',
  [LocalizationKeys.Page.ResetPassord.WrongUrlParameters]:
    "Mauvais paramètres dans l'URL",
  [LocalizationKeys.Page.ResetPassord.Success]:
    'Mot de passe modifié avec succès. Vous pouvez continuer à la connexion.',
  [LocalizationKeys.Page.ResetPassord.Failure]:
    'Erreur lors de la modification de votre mot de passe. Réessayez plus tard.',

  [LocalizationKeys.Page.ProfilesPage.Title]: 'Bonjour {{name}}',
  [LocalizationKeys.Page.ProfilesPage.SubscriptionActivated]:
    'Votre abonnement est activé',

  [LocalizationKeys.Page.ContactsPage.Title]: 'Audience',
  [LocalizationKeys.Page.ContactsPage.Username]: 'Utilisateur',
  [LocalizationKeys.Page.ContactsPage.IsFollowing]: 'Est follower',
  [LocalizationKeys.Page.ContactsPage.FollowersCount]: 'Nombre de followers',
  [LocalizationKeys.Page.ContactsPage.LastStoryMention]:
    'Dernière mention en story',
  [LocalizationKeys.Page.ContactsPage.LastInteraction]: 'Dernière interaction',
  [LocalizationKeys.Page.ContactsPage.FirstInteraction]: 'Première interaction',

  [LocalizationKeys.Page.AutomationPage.Title]:
    'Réponses aux mentions en story',
  [LocalizationKeys.Page.AutomationPage.Status]: "L'automation est {{status}}",
  [LocalizationKeys.Page.AutomationPage.StatusLive]: 'en cours',
  [LocalizationKeys.Page.AutomationPage.StatusScheduled]: 'programmée',
  [LocalizationKeys.Page.AutomationPage.StatusPaused]: 'en pause',
  [LocalizationKeys.Page.AutomationPage.Settings]: 'Réglages',
  [LocalizationKeys.Page.AutomationPage.Save]: 'Sauvegarder',
  [LocalizationKeys.Page.AutomationPage.Edit]: 'Modifier',

  [LocalizationKeys.Page.ProfileSettingsPage.Title]: 'Réglages',
  [LocalizationKeys.Page.ProfileSettingsPage.InstagramUserID]:
    'Identifiant utilisateur Instagram : ',
  [LocalizationKeys.Page.ProfileSettingsPage.InstagramUsername]:
    "Nom d'utilisateur Instagram : ",
  [LocalizationKeys.Page.ProfileSettingsPage.InstagramPermissions]:
    'Permissions Instagram : ',
  [LocalizationKeys.Page.ProfileSettingsPage.DangerZone]: 'Zone dangereuse',
  [LocalizationKeys.Page.ProfileSettingsPage.DeleteButton]: 'Supprimer',
  [LocalizationKeys.Page.ProfileSettingsPage.DeleteExplanation]:
    "Supprime le compte Instagram de votre compte Echow. L'automation cessera de fonctionner immédiatement et toutes les ressources associées à votre compte Instagram seront supprimées. Votre abonnement sera immédiatement arrêté. Cette opération est irréversible.",
  [LocalizationKeys.Page.ProfileSettingsPage.DeleteProfil]:
    'Supprimer le profil',
  [LocalizationKeys.Page.ProfileSettingsPage.PlanAndBilling]:
    'Plan & Facturation',

  [LocalizationKeys.Page.UserProfilePage.Title]: 'Mon profil',
  [LocalizationKeys.Page.UserProfilePage.DeleteWholeAccountTitle]:
    'Supprimer mon compte & mes profils',
  [LocalizationKeys.Page.UserProfilePage.DeleteWholeAccountDescription]:
    'Cette action supprimera votre compte et tous vos profils Instagram. Cette action arrête immédiatement toutes les automations et supprime toutes vos données de notre plateforme. Cette action est irréversible.',
  [LocalizationKeys.Page.UserProfilePage.DeleteWholeAccountConfirmation]:
    'Êtes-vous sûr de vouloir supprimer votre compte ? Toutes les données seront supprimées. Cette action est immédiate et irréversible.',
  [LocalizationKeys.Page.UserProfilePage.AccountDeleted]:
    'Votre compte a bien été supprimé',

  [LocalizationKeys.Page.OnboardingRegistrationPage.Error]: 'Erreur',
  [LocalizationKeys.Page.OnboardingRegistrationPage.DescriptionError]:
    "Erreur lors de la création de votre compte. Contactez le support si l'erreur persiste.",
  [LocalizationKeys.Page.OnboardingRegistrationPage.Back]: 'Retour',
  [LocalizationKeys.Page.OnboardingRegistrationPage.HappyToSeeYou]:
    'Heureux de vous revoir 🚀',

  [LocalizationKeys.Page.OnboardingStepsIndustryPage.FieldActivity]:
    "Quel est votre domaine d'activité",
  [LocalizationKeys.Page.OnboardingStepsIndustryPage.CheckMention]:
    "Je reconnais avoir lu et accepte sans réserves <0>les Conditions Générales d'Utilisation (CGU)</0> et <1>la Politique de Confidentialité</1> .",
  [LocalizationKeys.Page.OnboardingStepsIndustryPage.Continue]: 'Continuer',

  [LocalizationKeys.Page.OnboardingStepsNamePage.Name]: 'Votre nom et prénom',

  [LocalizationKeys.Page.OnboardingStepsEmailPage.Email]: 'Votre adresse email',

  [LocalizationKeys.Page.OnboardingStepsPasswordPage.Password]:
    'Votre mot de passe',

  [LocalizationKeys.Page.ProfileFormDeletePage.Delete]:
    'Vous êtes sûr de vouloir supprimer ?',
  [LocalizationKeys.Page.ProfileFormDeletePage.AllDataDelete]:
    'Toutes les ressources connexes (automations, réponses, données analytiques, ...) seront également supprimées de façon permanente. Votre abonnement sera immédiatement arrêté. Cette action est irréversible.',
  [LocalizationKeys.Page.ProfileFormDeletePage.InputConfirmation]:
    'Saisissez {{ itemName }} pour confirmer',

  [LocalizationKeys.Layout.ProfileHeader.Audience]: 'Audience',
  [LocalizationKeys.Layout.ProfileHeader.Campaigns]: 'Campagnes',
  [LocalizationKeys.Layout.ProfileHeader.Automation]: 'Automation',
  [LocalizationKeys.Layout.ProfileHeader.Activity]: 'Activité',
  [LocalizationKeys.Layout.ProfileHeader.Settings]: 'Réglages',

  [LocalizationKeys.Layout.RightHeader.Profile]: 'Profil',
  [LocalizationKeys.Layout.RightHeader.Settings]: 'Réglages',
  [LocalizationKeys.Layout.RightHeader.Lang]: 'Langue',
  [LocalizationKeys.Layout.RightHeader.Legal]: 'Informations légales',
  [LocalizationKeys.Layout.RightHeader.Logout]: 'Déconnexion',

  [LocalizationKeys.Component.Answer.Analytics.TotalSent]: 'Total envoyés',
  [LocalizationKeys.Component.Answer.Analytics.OpeningRate]: "Taux d'ouverture",
  [LocalizationKeys.Component.Answer.Card.IfUserIsFollower]:
    "Si l'utilisateur suit votre compte",
  [LocalizationKeys.Component.Answer.Card.IfUserIsNotFollower]:
    "Si l'utilisateur ne suit pas votre compte",
  [LocalizationKeys.Component.Answer.List.ButtonInteractions]:
    'Interactions buttons',
  [LocalizationKeys.Component.Answer.List.Attachments]: 'Pièce jointe',

  [LocalizationKeys.Component.Automation.Update.Status]: "Statut d'automation",
  [LocalizationKeys.Component.Automation.Update.ReactionLabel]:
    'Automation ♥ réaction',
  [LocalizationKeys.Component.Automation.Update.ReactionHelp]:
    'Automatiquement liker la mention en story.',
  [LocalizationKeys.Component.Automation.Update.MessageDelayLabel]:
    'Délai entre messages',
  [LocalizationKeys.Component.Automation.Update.MessageDelayHelp]:
    "Mettre un délai entre les réponses et réactions pour éviter l'impression de spam.\nMin: 0\nMax: 15",
  [LocalizationKeys.Component.Automation.Update.Follower]: 'Follower',
  [LocalizationKeys.Component.Automation.Update.NonFollower]: 'Non follower',
  [LocalizationKeys.Component.Automation.Update.ReplyDelayLabel]:
    'Délai de réponse',
  [LocalizationKeys.Component.Automation.Update.ReplyDelayHelp]:
    "Temps avant d'envoyer de démarrer l'automation après avoir reçu la mention en story, selon le type de contact.\nMin: 0\nMax: 2880 (48h)",
  [LocalizationKeys.Component.Automation.Update.ReplyLimitLabel]:
    'Limite de réponse',
  [LocalizationKeys.Component.Automation.Update.ReplyLimitHelp]:
    "Temps avant que l'automation se déclenche de nouveau pour le même contact, selon le type de contact.\nMin: 0\nMax: 2880 (48h)",

  [LocalizationKeys.Component.Profile.AddCard.ConnectError]:
    'Une erreur est survenue lors de la connexion de votre compte Instagram.',
  [LocalizationKeys.Component.Profile.AddCard.RegisterError]: 'Erreur',
  [LocalizationKeys.Component.Profile.AddCard.RegisterErrorDetails]:
    "Erreur lors de la création de votre compte. Réessayez ou contactez le support si l'erreur persiste.",
  [LocalizationKeys.Component.Profile.AddCard
    .RegisterErrorDetailsAlreadyConnected]:
    'Ce compte Instagram est déjà connecté à un compte Echow',
  [LocalizationKeys.Component.Profile.AddCard.TryAgain]: 'Réessayer',
  [LocalizationKeys.Component.Profile.AddCard.Connect]: 'Connecter un compte',
  [LocalizationKeys.Component.Profile.AddCard.Awaiting]:
    "En attente de réponse d'Instagram",
  [LocalizationKeys.Component.Profile.AddCard.Creating]: 'Création du profil',

  [LocalizationKeys.Component.Profile.BillingPortal.BillingPortal]:
    'Gérer mon abonnement',

  [LocalizationKeys.Component.Profile.ConnectFlow.AddInstagramAccount]:
    'Connecter votre compte Instagram',
  [LocalizationKeys.Component.Profile.ConnectFlow.CheckMention]:
    "Je reconnais avoir lu et accepte sans réserves <0>les Conditions Générales d'Abonnement (CGA)</0>.",
  [LocalizationKeys.Component.Profile.ConnectFlow.LoginWithInstagram]:
    'CONNEXION AVEC INSTAGRAM',
  [LocalizationKeys.Component.Profile.ConnectFlow.Welcome]:
    'Choisissez votre formule',
  [LocalizationKeys.Component.Profile.ConnectFlow.ChoosePlan]:
    'Choisissez un plan pour terminer votre inscription',
  [LocalizationKeys.Component.Profile.ConnectFlow.InstagramConnection]:
    "En connectant votre compte Instagram à Echow, vous profitez d'un outil dédié à la gestion de vos mentions en Story. Vos données sont strictement sécurisées et utilisées uniquement pour améliorer votre expérience sur la plateforme.",

  [LocalizationKeys.Component.Subscription.StatusTag.Trial]:
    "{{dayRemaining}} jour(s) d'essai restant(s)",
  [LocalizationKeys.Component.Subscription.StatusTag.Paused]:
    'Abonnement en pause',
  [LocalizationKeys.Component.Subscription.StatusTag.PaymentRequired]:
    'Paiement requis',
  [LocalizationKeys.Component.Subscription.StatusTag.Canceled]:
    'Abonnement annulé',
  [LocalizationKeys.Component.Subscription.StatusTag.PaymentError]:
    'Erreur de paiement',

  [LocalizationKeys.Component.Subscription.InvoicesCard.ViewAllInvoices]:
    'Voir toutes les factures',

  [LocalizationKeys.Component.Subscription.SummaryCard.Plan]:
    'Abonnement {{planName}}',
  [LocalizationKeys.Component.Subscription.SummaryCard.NextPayment]:
    'Prochain paiement le {{date}}',
  [LocalizationKeys.Component.Subscription.SummaryCard.Monthly]: 'mois',
  [LocalizationKeys.Component.Subscription.SummaryCard.Annual]: 'an',
  [LocalizationKeys.Component.Subscription.SummaryCard.SaveWithAnnualPayment]:
    "Économisez 2 mois d'abonnement avec le paiement annuel",

  [LocalizationKeys.Component.Profile.Card.AutomationIsLive]:
    'Automation est en cours',
  [LocalizationKeys.Component.Profile.Card.AutomationIsPaused]:
    'Automation en pause',
  [LocalizationKeys.Component.Profile.Card.ChoosePlanForUser]:
    'Choisissez un plan pour {{username}}',

  [LocalizationKeys.Auth.Error.LoginError]:
    "Vérifiez que vos identifiants soient corrects. Réessayez plus tard si l'erreur persiste",

  [LocalizationKeys.Misc.Error.Required]: 'Le champ est requis',
  [LocalizationKeys.Misc.Error.TypeString]:
    "L'entrée n'est pas une chaîne de caractères valide",
  [LocalizationKeys.Misc.Error.TypeNumber]:
    "L'entrée n'est pas un nombre valide",
  [LocalizationKeys.Misc.Error.TypeLink]: "L'entrée n'est pas un lien valide",
  [LocalizationKeys.Misc.Error.TypeEmail]: "L'entrée n'est pas un email valide",
  [LocalizationKeys.Misc.Error.NotValidPhone]:
    "L'entrée n'est pas un numéro de téléphone valide",
  [LocalizationKeys.Misc.Error.MinLength]:
    'La valeur doit avoir au moins {{length}} caractères',
  [LocalizationKeys.Misc.Error.Caps]:
    'La valeur doit contenir au moins une lettre capitale',
  [LocalizationKeys.Misc.Error.Lowercase]:
    'La valeur doit contenir au moins une lettre minuscule',
  [LocalizationKeys.Misc.Error.ContainsNumber]:
    'La valeur doit contenir au moins un chiffre',
  [LocalizationKeys.Misc.Error.ContainsSymbol]:
    'La valeur doit contenir au moins un symbole',
  [LocalizationKeys.Misc.Error.MismatchValue]:
    'La valeur ne correspond pas à la valeur attendue',

  [LocalizationKeys.Misc.Form.Title]: 'Titre',
  [LocalizationKeys.Misc.Form.Description]: 'Description',
  [LocalizationKeys.Misc.Form.Name]: 'Nom',
  [LocalizationKeys.Misc.Form.Slug]: 'Slug',
  [LocalizationKeys.Misc.Form.FirstName]: 'Prénom',
  [LocalizationKeys.Misc.Form.LastName]: 'Nom',
  [LocalizationKeys.Misc.Form.Username]: 'Username',
  [LocalizationKeys.Misc.Form.Email]: 'Email',
  [LocalizationKeys.Misc.Form.Phone]: 'Téléphone',
  [LocalizationKeys.Misc.Form.Password]: 'Mot de passe',
  [LocalizationKeys.Misc.Form.PasswordConfirmation]:
    'Confirmation du mot de passe',
  [LocalizationKeys.Misc.Form.RememberMe]: 'Se souvenir de moi',
  [LocalizationKeys.Misc.Form.Add]: 'Ajouter',
  [LocalizationKeys.Misc.Form.Label]: 'Texte',
  [LocalizationKeys.Misc.Form.URL]: 'URL',
  [LocalizationKeys.Misc.Form.Message]: 'Message',
  [LocalizationKeys.Misc.Form.Minutes]: 'minutes',
  [LocalizationKeys.Misc.Form.Seconds]: 'secondes',
  [LocalizationKeys.Misc.Form.Hours]: 'heures',

  [LocalizationKeys.Misc.Form.Attachment]: 'Pièce jointe',
  [LocalizationKeys.Misc.Form.AddAttachment]: 'Nouvelle pièce jointe',
  [LocalizationKeys.Misc.Form.FileSizeExceeds]:
    'Le fichier dépasse la taille autorisée',
  [LocalizationKeys.Misc.Form.FileClicOrDrag]:
    'Cliquez ou glissez le fichier dans cette zone',
  [LocalizationKeys.Misc.Form.FileCanBe]: 'Le fichier peut être au choix : ',
  [LocalizationKeys.Misc.Form.FileMaxSize]: 'Taille maximale 10Mo',
  [LocalizationKeys.Misc.Form.Buttons]: 'Interactions',
  [LocalizationKeys.Misc.Form.AddButtonInteraction]: 'Ajouter une interaction',

  [LocalizationKeys.Misc.Form.AreYouSureToDelete]:
    'Êtes-vous sûr de vouloir supprimer cette ressource ?',

  [LocalizationKeys.Misc.Button.Update]: 'Modifier',
  [LocalizationKeys.Misc.Button.Delete]: 'Supprimer',
  [LocalizationKeys.Misc.Button.Save]: 'Sauvegarder',
  [LocalizationKeys.Misc.Button.Cancel]: 'Annuler',
  [LocalizationKeys.Misc.Button.Help]: 'Aide',

  [LocalizationKeys.SBRM.EntityNotDefined]:
    'Choisissez une action et revenez plus tard',
  [LocalizationKeys.SBRM.Close]: 'Fermer',
  [LocalizationKeys.SBRM.Delete]: 'Supprimer',
  [LocalizationKeys.SBRM.Save]: 'Sauvegarder',
  [LocalizationKeys.SBRM.Update]: 'Modifier',
  [LocalizationKeys.SBRM.AddNew]: 'Ajouter',
  [LocalizationKeys.SBRM.Duplicate]: 'Dupliquer',
  [LocalizationKeys.SBRM.View]: 'Voir',
  [LocalizationKeys.SBRM.Comment]: 'Commenter',
  [LocalizationKeys.SBRM.DeleteConfirmation]:
    'Êtes-vous sûr de vouloir supprimer ?',

  [LocalizationKeys.SBRMTitle.AddNew]: 'Ajouter un nouveau {{type}}',
  [LocalizationKeys.SBRMTitle.CreateNew]: 'Créer un nouveau {{type}}',
  [LocalizationKeys.SBRMTitle.Edit]: 'Modifier {{type}}',
  [LocalizationKeys.SBRMTitle.Delete]: 'Supprimer {{type}}',
  [LocalizationKeys.SBRMTitle.Comment]: 'Commenter {{type}}',
  [LocalizationKeys.SBRMTitle.View]: 'Voir {{type}}',
  [LocalizationKeys.SBRMTitle.Upload]: 'Téléverser {{type}}',
  [LocalizationKeys.SBRMTitle.Duplicate]: 'Dupliquer {{type}}',
  [LocalizationKeys.SBRMTitle.Assign]: 'Assigner {{type}}',
  [LocalizationKeys.SBRMTitle.Invite]: 'Inviter {{type}}',
  [LocalizationKeys.SBRMTitle.Cancel]: 'Annuler {{type}}',

  [LocalizationKeys.Entity.user]: 'utilisateur',
  [LocalizationKeys.Entity.profile]: 'profils',
  [LocalizationKeys.Entity.automation]: 'automations',
  [LocalizationKeys.Entity.answer]: 'answers',
  [LocalizationKeys.Entity.contact]: 'contact',
  [LocalizationKeys.Entity.analyticsEvent]: 'évènement',
}

export default French
